
const $fadein = $('.js-fadein')

$(window).on('load resize scroll', function() {
  var threshold = $(this).scrollTop() + $(this).outerHeight(true)
  $('.js-fadein').each(function() {
    if(threshold - 20 > $(this).offset().top) {
      $(this).addClass('is-visible')
    }
  })
})

$('.product-media-modal__content').on('scroll', function() {
  var threshold = $(window).scrollTop() + $(window).outerHeight(true)
  $('.js-fadein').each(function() {
    if(threshold - 20 > $(this).offset().top) {
      $(this).addClass('is-visible')
    }
  })
})

const $scaledown = $('.js-scaledown')

$(window).on('load resize scroll', function() {
  var threshold = $(this).scrollTop() + $(this).outerHeight(true)
  $('.js-scaledown').each(function() {
    if(threshold - 20 > $(this).offset().top) {
      $(this).addClass('is-visible')
    }
  })
})

const $stayin = $('.js-stain')

$(window).on('load resize scroll', function() {
  var threshold = $(this).scrollTop() + $(this).outerHeight(true)
  $('.js-stayin').each(function() {
    if(threshold - 20 > $(this).offset().top) {
      $(this).addClass('is-visible')
    }
  })
})